import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { differenceInCalendarISOWeeks } from 'date-fns';
import { filter, map, pairwise } from 'rxjs';
import { TaskActions } from '../task/task.actions';
import { PlanPageActions } from './plan.actions';
import { PlanFacade } from './plan.facade';
import { HomiSettingsActions } from '@lyceo/shared/homi-settings/data-access';
import { isDefined } from '@lyceo/shared/util';

@Injectable()
export class PlanEffects {
  private readonly actions$ = inject(Actions);
  private readonly planFacade: PlanFacade = inject(PlanFacade);

  public prefetchOnActiveDateChange$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PlanPageActions.activeDateChanged),
      pairwise(),
      map(([previous, current]) => {
        if (differenceInCalendarISOWeeks(previous.date, current.date) > 0) {
          return TaskActions.prefetchCalendarPrevious();
        }
        return TaskActions.prefetchCalendarNext();
      }),
    );
  });

  public syncElo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PlanPageActions.syncEloClicked),
      map(() => this.planFacade.pupilId()),
      filter(isDefined),
      map((pupilId) => HomiSettingsActions.syncElo({ pupilId })),
    );
  });
}
